<div class="panel-group">
  <ngb-accordion #acc='ngbAccordion'>
    <ng-container *ngFor='let group of payload?.groups; index as i'>
      <ngb-panel [cardClass]="'panel-group'" [disabled]='disabledChangeGroup' id='{{groupIdPrefix}}{{i}}'>
        <ng-template ngbPanelHeader>
          <div (click)='clickGroup(group, true)'
               *ngIf='group.enabled'
               [ngClass]="{
               'current-edit-group': currentEditGroup?.id === group.id,
               'disabled-group': currentEditGroup && currentEditGroup.id !== group.id
               }"
               class='panel-header'>

            <div [ngClass]="{
                 'text-success': status?.validGroupId?.includes(group?.id),
                 'text-warning': !status?.validGroupId?.includes(group?.id) && status?.loadedGroupId?.includes(group.id)
                 }"
                 class='icon'>
              <ng-container *ngIf='status?.loadedGroupId?.includes(group.id)'>
                <pt-icon
                  [key]='status?.validGroupId?.includes(group?.id) ? IconCheck : IconWarning'>
                </pt-icon>
              </ng-container>

              <ng-container *ngIf='!status?.loadedGroupId?.includes(group.id)'>
                <div class='spinner-border spinner-border-sm' role='status'>
                  <span class='visually-hidden'>Loading...</span>
                </div>
              </ng-container>
            </div>

            <div class='label'
                 container='body'
                 ngbTooltip='{{group.name}}'
                 placement='top'>
              {{ group.name }}
            </div>
          </div>
        </ng-template>

        <ng-template ngbPanelContent>
          <ul class='widget-list'>
            <ng-container *ngFor='let widget of group.widgets'>
              <li>
                <ng-container *ngIf='isVisibleWidget(widget)'>
                  <div [ngClass]="{
                    'text-success': status?.validWidgetId?.includes(widget?.internalId),
                    'text-error': status?.errorWidgetId?.includes(widget?.internalId),
                    'text-warning': !status?.validWidgetId?.includes(widget?.internalId)
                    }"
                       class='sidebar-widget-loader'>
                    <ng-container
                      *ngIf='isCompleted(widget?.internalId); then WIDGET_COMPLETED; else WIDGET_LOADING;'
                    ></ng-container>

                    <ng-template #WIDGET_COMPLETED>
                      <pt-icon [key]='status?.validWidgetId?.includes(widget?.internalId) ? IconCheck : IconWarning'
                               [size]='16'></pt-icon>
                    </ng-template>

                    <ng-template #WIDGET_LOADING>
                      <div class='spinner-border spinner-border-sm' role='status'>
                        <span class='visually-hidden'>Loading...</span>
                      </div>
                    </ng-template>
                  </div>
                  <div [ptWidgetSelector]='widget.internalId?.toString()'
                       class='text text-truncate ms-2'
                       container='body'
                       ngbTooltip='{{widget.label}}'
                       placement='top'>
                    {{ widget.label ? widget.label : ("LABELS.INFO" | translate) }}
                  </div>
                </ng-container>

              </li>
            </ng-container>
          </ul>
        </ng-template>
      </ngb-panel>
    </ng-container>
  </ngb-accordion>
</div>


